import { Component } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

const exampleHtml = `
  <se-po-affiliation-access [orgId]="orgId">
  </se-po-affiliation-access>
`

const exampleTypescript = `
import { Component } from '@angular/core'

export class AffiliationAccessExampleComponent {

  public orgId = 530

  constructor() {
  }

}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-affiliation-access-example',
  template,
  styleUrls: ['./affiliation-access-docs.component.scss'],
  standalone: false,
})
export class AffiliationAccessExampleComponent extends SeFeDocsExampleComponent {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public orgId = 530

  constructor() {
    super()
  }
}
